import React, {ReactNode} from 'react';
import {Box, Paper, Stack, Typography} from "@mui/material";
import {alpha} from "@mui/material/styles";
import {adminCardSurface} from "@containers/adminAccounts/ui/adminSurface";

interface IProps {
	title: string,
	icon?: ReactNode,
	hint?: ReactNode,
	children: ReactNode,
}

const SectionCard = ({title, icon, hint, children}: IProps) => (
	<Paper
		elevation={0}
		sx={(theme) => ({
			...adminCardSurface(theme),
			borderRadius: 2.5,
			p: {xs: 1.5, md: 2},
			border: 1,
			borderColor: 'transparent',
			transition: 'box-shadow .2s, border-color .2s',
			'&:focus-within': {
				borderColor: alpha(theme.palette.primary.main, 0.4),
				boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.06)}`,
			},
		})}
	>
		<Stack direction={'row'} alignItems={'center'} gap={1} sx={{mb: 1.5}}>
			{icon && <Box
				sx={(theme) => ({
					width: 28,
					height: 28,
					borderRadius: 2,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					color: theme.palette.primary.main,
					bgcolor: alpha(theme.palette.primary.main, 0.12),
					'& svg': {fontSize: 16},
				})}
			>
				{icon}
			</Box>}
			<Box>
				<Typography sx={{fontSize: 15, fontWeight: 700, lineHeight: 1.3}}>{title}</Typography>
				{hint && <Typography sx={{fontSize: 12, lineHeight: 1.4}} color={'text.secondary'}>{hint}</Typography>}
			</Box>
		</Stack>
		<Stack gap={1.5}>
			{children}
		</Stack>
	</Paper>
);

export default SectionCard;
